module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6dcXm"))).then(() => module.bundle.root('lKlEc'));